import { useState } from "react";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem("hc-cookie-consent"));
  if (!visible) return null;

  const accept = () => {
    localStorage.setItem("hc-cookie-consent", "1");
    setVisible(false);
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 bg-[#1A1D1A]/95 backdrop-blur text-[#FBF9F5] border-t border-[#323832]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-stone-300 flex items-start gap-2.5">
          <Cookie className="w-5 h-5 text-[#D97706] shrink-0 mt-0.5" />
          <span>
            Stran uporablja nujno potrebne piškotke za delovanje košarice in prijave. Podrobnosti najdete v{" "}
            <a href="/piskotki" data-testid="cookie-banner-link" className="underline text-[#D97706] hover:text-[#F59E0B]">
              pravilniku o piškotkih
            </a>.
          </span>
        </p>
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="shrink-0 h-10 px-7 rounded-full bg-[#D97706] text-white text-sm font-semibold hover:bg-[#B45309] transition-colors"
        >
          Sprejmem
        </button>
      </div>
    </div>
  );
}
